import { onBeforeUnmount, ref, watch, type Ref } from 'vue'

/** Teleported presentation keeps the originating specimen's theme and hue. */
export function useMmPortalTheme(origin: Ref<HTMLElement | null>, open: Ref<boolean>) {
  const theme = ref('dark')
  const hue = ref('350')
  let observer: MutationObserver | undefined
  const sync = () => {
    const root = origin.value?.closest<HTMLElement>('[data-theme]') || document.documentElement
    if (!root) return
    theme.value = root.dataset.theme || 'dark'
    hue.value = getComputedStyle(root).getPropertyValue('--live-h').trim() || '350'
  }
  watch([open, origin], ([visible]) => {
    observer?.disconnect()
    if (!visible || typeof window === 'undefined') return
    sync()
    const root = origin.value?.closest('[data-theme]') || document.documentElement
    if (root) {
      observer = new MutationObserver(sync)
      observer.observe(root, { attributes: true, attributeFilter: ['data-theme', 'style'] })
    }
  }, { flush: 'post' })
  onBeforeUnmount(() => observer?.disconnect())
  return { theme, hue }
}
